export const dashboardHeaderCards = [
  {
    title: "No. of Assessments",
    backgroundColor: "#FFE2E5",
    value: "12.4k",
    icon: "bx bx-bar-chart",
    iconBackgroundColor: "#FA5A7D",
    iconColor: "#ffffff",
  },
  {
    title: "No. of Questions",
    backgroundColor: "#FFF4DE",
    value: "2.4k",
    icon: "mdi mdi-file-document",
    iconBackgroundColor: "#FF947A",
    iconColor: "#ffffff",
  },
  {
    title: "Total No. of Candidate Invites",
    backgroundColor: "#F3E8FF",
    value: "1.4k",
    icon: "mdi mdi-account-plus",
    iconBackgroundColor: "#BF83FF",
    iconColor: "#ffffff",
  },
  {
    title: "Completed Candidate Reports",
    backgroundColor: "#DCFCE7",
    value: "15",
    icon: "mdi mdi-bookmark",
    iconBackgroundColor: "#3CD856",
    iconColor: "#ffffff",
  },
];

export const resultData = [
  {
    title: "Result 1",
    candidates: 12,
    completed: 22,
    expireDate: "Jan 25, 2025",
    questions: 35,
    reports: 15,
    time: "70 min",
  },
  {
    title: "Result 2",
    candidates: 9,
    completed: 19,
    expireDate: "Feb 20, 2025",
    questions: 28,
    reports: 14,
    time: "50 min",
  },
  {
    title: "Result 3",
    candidates: 7,
    completed: 16,
    expireDate: "Mar 15, 2025",
    questions: 22,
    reports: 11,
    time: "40 min",
  },
];

export const questionPaperData = [
  {
    title: "Question 1",
    candidates: 5,
    completed: 15,
    expireDate: "Jan 15, 2025",
    questions: 20,
    reports: 5,
    time: "45 min",
  },
  {
    title: "Question 2",
    candidates: 3,
    completed: 8,
    expireDate: "Feb 10, 2025",
    questions: 15,
    reports: 7,
    time: "60 min",
  },
  {
    title: "Question 3",
    candidates: 2,
    completed: 12,
    expireDate: "Mar 5, 2025",
    questions: 25,
    reports: 10,
    time: "30 min",
  },
];
